"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Rocket2_exports = {};
__export(Rocket2_exports, {
  default: () => Rocket2_default
});
module.exports = __toCommonJS(Rocket2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.9023 2.82812C17.8763 2.80208 17.8438 2.78255 17.8047 2.76953C17.7656 2.75651 17.7266 2.75 17.6875 2.75C16.8932 2.75 16.1641 2.80859 15.5 2.92578C14.8359 3.02995 14.2435 3.1862 13.7227 3.39453C13.2018 3.61589 12.668 3.92839 12.1211 4.33203C11.5742 4.72266 11.0143 5.20443 10.4414 5.77734C10.194 6.02474 9.93359 6.29818 9.66016 6.59766C9.39974 6.89714 9.11979 7.22266 8.82031 7.57422L5.34375 7.75C5.29167 7.75 5.24609 7.76302 5.20703 7.78906C5.16797 7.8151 5.13542 7.85417 5.10938 7.90625L3.03906 11.4219C3.01302 11.487 3 11.5521 3 11.6172C3.01302 11.6693 3.04557 11.7279 3.09766 11.793L3.68359 12.3789C3.70964 12.4049 3.73568 12.4245 3.76172 12.4375C3.80078 12.4505 3.84635 12.457 3.89844 12.457C3.91146 12.457 3.92448 12.457 3.9375 12.457C3.95052 12.457 3.96354 12.4505 3.97656 12.4375L6.51562 11.6562L9.09375 14.2539L8.3125 16.793C8.29948 16.8451 8.29948 16.8971 8.3125 16.9492C8.32552 16.9883 8.35156 17.0339 8.39062 17.0859L8.97656 17.6719C9.0026 17.6979 9.03516 17.7174 9.07422 17.7305C9.11328 17.7435 9.14583 17.75 9.17188 17.75C9.21094 17.75 9.23698 17.75 9.25 17.75C9.27604 17.737 9.30208 17.724 9.32812 17.7109L12.8633 15.6602C12.9023 15.6211 12.9349 15.582 12.9609 15.543C12.987 15.5039 13 15.4583 13 15.4062L13.1953 11.9297C13.5339 11.6432 13.8529 11.3633 14.1523 11.0898C14.4518 10.8164 14.7253 10.556 14.9727 10.3086C15.5195 9.76172 15.9883 9.21484 16.3789 8.66797C16.7695 8.10807 17.0755 7.55469 17.2969 7.00781C17.5312 6.44792 17.707 5.84245 17.8242 5.19141C17.9414 4.52734 18 3.8112 18 3.04297C18 3.00391 17.9935 2.97135 17.9805 2.94531C17.9674 2.90625 17.9414 2.86719 17.9023 2.82812ZM15.6758 6.32422C15.5977 6.40234 15.5065 6.46745 15.4023 6.51953C15.2982 6.55859 15.181 6.57812 15.0508 6.57812C14.9336 6.57812 14.8229 6.55859 14.7188 6.51953C14.6146 6.46745 14.5234 6.40234 14.4453 6.32422C14.3542 6.23307 14.2826 6.13542 14.2305 6.03125C14.1914 5.92708 14.1719 5.81641 14.1719 5.69922C14.1719 5.56901 14.1914 5.45182 14.2305 5.34766C14.2826 5.24349 14.3542 5.15234 14.4453 5.07422C14.5234 4.98307 14.6146 4.91797 14.7188 4.87891C14.8229 4.82682 14.9336 4.80078 15.0508 4.80078C15.181 4.80078 15.2982 4.82682 15.4023 4.87891C15.5065 4.91797 15.5977 4.98307 15.6758 5.07422C15.7669 5.15234 15.832 5.24349 15.8711 5.34766C15.9232 5.45182 15.9492 5.56901 15.9492 5.69922C15.9492 5.81641 15.9232 5.92708 15.8711 6.03125C15.832 6.13542 15.7669 6.23307 15.6758 6.32422Z",
      fill: "currentColor"
    }
  )
);
const SvgRocket2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Rocket2_default = SvgRocket2;
